<div class="d-flex justify-content-between align-items-center w-100">

    <div class="d-flex align-items-center gap-3">
        <app-page-header Heading="SMS Configuration" Description="">
        </app-page-header>

        <app-pagination [EnablePageSize]="true" [rowData]="smsConfigList"
            (pageSizeChanged)="handlePageSizeChange($event)">
        </app-pagination>
    </div>

    <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-primary shadow-sm" (click)="openSmsConfigForm()" [disabled]="isLoading">
            Add New SMS Configuration
        </button>
    </div>

</div>

<ng-container *ngIf="isLoading; else smsConfigTableContent">
    <div class="card mb-1">
        <div class="card-header d-flex align-items-center">
            <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
            <span class="ml-2">
                <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
            </span>
        </div>
        <div class="card-body">
            <ngx-skeleton-loader count="3" width="100%" height="14px" style="margin-bottom: 8px;"></ngx-skeleton-loader>
        </div>
    </div>
</ng-container>

<ng-template #smsConfigTableContent>
    <app-color-table [columns]="[

      { colName: 'Name', colData: 'cName' },
      { colName: 'Description', colData: 'cDesc' },
      { colName: 'SMS URL', colData: 'smsUrl' },
      { colName: 'Sender ID', colData: 'senderId' },
      { colName: 'User ID', colData: 'userId' },
      { colName: 'Channel', colData: 'channel' },
    
   
]" [tableData]="this.smsConfigList" [enableActionColumn]="true" [actionColumnLabel]="'Action'"
        [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'}]"
        (actionClick)="handleSmsActionClick($event)" [DataLoading]="isLoading">
        ></app-color-table>
</ng-template>

<app-pagination [EnableNavigation]="true" [rowData]="smsConfigList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination>

<ng-template #smsConfigModalContent>
    <div class="modal-header">
        <h5 class="modal-title">New SMS Configuration</h5>
        <button type="button" class="btn-close btn-close-white" (click)="addsmsConfigModalContent.close()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="smsConfigForm">

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="cName">Configuration Name <span style="color: red;">*</span></label>
                        <input type="text" class="form-control form-control-sm"
                            [formControl]="smsConfigForm.controls.cName" placeholder="Configuration Name">
                        <app-form-errors [control]="smsConfigForm.controls.cName"></app-form-errors>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="cDesc">Configuration Description</label>
                        <textarea class="form-control form-control-sm" [formControl]="smsConfigForm.controls.cDesc"
                            placeholder="Description"></textarea>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <label for="smsUrl">SMS URL <span style="color: red;">*</span></label>
                    <input type="text" class="form-control form-control-sm"
                        [formControl]="smsConfigForm.controls.smsUrl" placeholder="SMS Service URL">
                    <app-form-errors [control]="smsConfigForm.controls.smsUrl"></app-form-errors>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="channel">channel <span style="color: red;">*</span></label>
                        <input type="text" class="form-control form-control-sm"
                            [formControl]="smsConfigForm.controls.channel" placeholder="channel">
                        <app-form-errors [control]="smsConfigForm.controls.channel"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="senderId">Sender ID<span style="color: red;">*</span></label>
                        <input type="text" class="form-control form-control-sm"
                            [formControl]="smsConfigForm.controls.senderId" placeholder="Sender ID">
                            <app-form-errors [control]="smsConfigForm.controls.senderId"></app-form-errors>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="User Id">User ID<span style="color: red;">*</span></label>
                        <input type="text" class="form-control form-control-sm"
                            [formControl]="smsConfigForm.controls.userId" placeholder="User ID">
                        <app-form-errors [control]="smsConfigForm.controls.userId"></app-form-errors>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="password">Password<span style="color: red;">*</span></label>
                        <div class="input-group input-group-sm">
                            <input [type]="passwordFieldType" class="form-control"
                                [formControl]="smsConfigForm.controls.password" placeholder="password">
                                <app-form-errors [control]="smsConfigForm.controls.password"></app-form-errors>
                            <div class="input-group-append">
                                <span class="input-group-text" style="cursor: pointer;"
                                    (click)="togglePasswordVisibility()">
                                    <i
                                        [class]="passwordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </form>
    </div>

    <div class="modal-footer mt-3">
        <button type="button" class="btn btn-primary" (click)="submitSmsConfigForm()" [disabled]="isSubmitting">Submit</button>
        <button type="button" class="btn btn-secondary" (click)="addsmsConfigModalContent.close()">Close</button>
    </div>
</ng-template>